import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {LessonFacetsFilters, LessonFacetsService} from '@modules/activities/core/lesson-facets/lesson-facets.service';
import {LessonFacetItem} from '@modules/activities/core/lesson-facets/models';
import {ConceptEntity} from 'shared/models';
import {map} from 'rxjs/operators';
import {usingLoading} from 'shared/utils/rxjs';
import {Filter} from '@modules/activities/core/activities-search-engine/filter-selector/filter';
import {ChapterEntity} from 'fuse-core/services/chapters.service';
import {EducationalLevelEntity} from '@modules/activities/core/services/educational-level.service';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-chapter-filter-selector',
    templateUrl: './chapter-filter-selector.component.html',
    styleUrls: ['./chapter-filter-selector.component.scss'],
    standalone: false
})
export class ChapterFilterSelectorComponent implements OnInit {
    @Input() options: Partial<{ concepts: ConceptEntity[]; educationalLevels: EducationalLevelEntity[] }> = undefined;
    @Output() chapterSelected = new EventEmitter<ChapterEntity>();

    public isLoading = true;

    // private chaptersService = inject(ChaptersService);
    private lessonFacetsService = inject(LessonFacetsService);


    private chapterToFilter = (chapter: LessonFacetItem): Filter<LessonFacetItem> => ({
        label: chapter.name, // .get('name') ?? chapter.get('label'),
        id: chapter.id,
        icon: 'add',
        type: 'chapter',
        originalResource: chapter
    });

    public availableChaptersToFilters$: Observable<Filter<LessonFacetItem>[]>;

    ngOnInit(): void {
        const filters: LessonFacetsFilters = {};

        if (this.options?.educationalLevels?.length)
            filters.level = this.options?.educationalLevels?.map(e => +e.id);

        if (this.options?.concepts?.length)
            filters.concept = this.options?.concepts?.map(e => +e.id)

        // this.availableChaptersToFilters$ = this.chaptersService.getChapters({filters}).pipe(
        this.availableChaptersToFilters$ = this.lessonFacetsService.getLessonFacets({filters}).pipe(
            map((results) => results.attributes.chapters.map(e => this.chapterToFilter(e))),
            usingLoading((isLoading) => this.isLoading = isLoading)
        );
    }

    public onChapterFilterSelected($event: Filter<ChapterEntity>): void {
        this.chapterSelected.emit($event.originalResource);
    }
}
